// Theme management — persists user preference to localStorage
export function getTheme() {
  return localStorage.getItem('levare-theme') || 'dark';
}

export function setTheme(theme) {
  localStorage.setItem('levare-theme', theme);
  applyTheme(theme);
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export function initTheme() {
  const saved = getTheme();
  applyTheme(saved);
  return saved;
}
